module.exports = __webpack_public_path__ + "static/media/hermit_staff.42713dc8.png";